module.exports = __webpack_public_path__ + "static/media/mode-2021.69ae9ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2021.svg
// module id = 1031
// module chunks = 2